export default {
  state: {
    homeData: {},
    sleepData: {},
    watchData: {},
    warningNumHome: 0
  },
  mutations: {
    addHomeData(state, payload) {
      state.homeData = payload
    },
    addSleepData(state, payload) {
      state.sleepData = payload
    },
    addWatchData(state, payload) {
      state.watchData = payload
      console.log(state.watchData, '我是vuex数据');
    },
    addNumHome(state, payload) {
      state.warningNumHome = payload
      console.log(state.warningNumHome, '我是vuex预警数量');
    }

  },
  action: {

  },
  getter: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/warning.js